<div
  id="primaryHeader"
  class="global-menu"
  nz-dropdown
  nzBackdrop="false"
  [nzDropdownMenu]="mainMenu"
  nzTrigger="click"
  [(nzVisible)]="visible"
  (nzVisibleChange)="onMenuVisibleChange($event)"
  nzPlacement="bottomLeft"
  nzOverlayClassName="va-main-menu-overlay"
>
  My Insights
  <va-icon *ngIf="!visible" size="small" name="chevron-down"></va-icon>
  <va-icon *ngIf="visible" size="small" name="chevron-up"></va-icon>
</div>

<nz-dropdown-menu #mainMenu="nzDropdownMenu">
  <div nz-menu class="va-main-menu">
    <va-icon
      size="small"
      name="close"
      class="close-button"
      (click)="onMenuVisibleChange(false)"
    ></va-icon>
    <div class="inline-div">
      <div class="header-container">
        <span class="header">Explore VA Insights </span>
      </div>
      <div class="list-group">
        <div class="account-option-list">
          <ng-container *ngFor="let menu of globalHeader.menuOption">
            <div nz-menu-item class="account-option" *ngIf="!menu.values">
              <a
                *ngIf="menu.functionOnClick"
                (click)="menu.functionOnClick(menu)"
              >
                {{ menu.name }}
              </a>
              <a
                *ngIf="menu.isRouterLink && !menu.functionOnClick"
                routerLink="{{ menu.link }}"
                routerLinkActive="active"
              >
                {{ menu.name }}
              </a>
              <a
                *ngIf="!menu.isRouterLink && !menu.functionOnClick"
                [target]="menu.linkTarget || ''"
                href="{{ menu.link }}"
              >
                {{ menu.name }}
                <va-icon
                  *ngIf="menu.showLinkIcon"
                  class="link-icon"
                  size="small"
                  name="external-link"
                ></va-icon>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <div
        class="menu-skeleton-conatiner"
        *ngIf="
          !globalHeader ||
          !globalHeader.menuOption ||
          !globalHeader.menuOption.length
        "
      >
        <div *ngFor="let dummySection of [0, 1, 2, 3, 4]">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
      </div>
    </div>
    <div class="inline-div" *ngIf="isSellside || coverageOptions.length">
      <div class="header-container" *ngIf="modelsOptions.length">
        <span class="header">My Models </span>
      </div>
      <div class="list-group" *ngIf="modelsOptions.length">
        <div class="account-option-list">
          <div>
            <div
              nz-menu-item
              class="account-option"
              *ngFor="let data of modelsOptions"
            >
              <a *ngIf="data.isRouterLink" [routerLink]="data.link">{{
                data.name
              }}</a>
              <a *ngIf="!data.isRouterLink" href="{{ data.link }}">{{
                data.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- coverage section -->
      <div class="header-container" *ngIf="coverageOptions.length">
        <span class="header">Coverage </span>
      </div>
      <div class="list-group" *ngIf="coverageOptions.length">
        <div class="account-option-list">
          <div>
            <ng-container *ngFor="let data of coverageOptions">
              <div *ngIf="!data.hasSubMenu" nz-menu-item class="account-option">
                <a [routerLink]="data.link" *ngIf="!data.hasSubMenu">{{
                  data.name
                }}</a>
              </div>
              <div
                *ngIf="data.hasSubMenu"
                class="account-option"
                [ngClass]="[this[data.visibilityFlag] ? 'hover' : '']"
              >
                <a (click)="toggleMenu(data.visibilityFlag)"
                  >{{ data.name }}
                  <va-icon size="small" name="chevron-right"></va-icon>
                </a>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div
      class="inline-div"
      *ngIf="
        isSellside && (isAnalystCoverageVisible || isAssociateCoverageVisible)
      "
    >
      <ng-container *ngIf="isAnalystCoverageVisible">
        <ng-container
          *ngTemplateOutlet="
            analystList;
            context: { items: analystCoverageOptions }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="isAssociateCoverageVisible">
        <ng-container
          *ngTemplateOutlet="
            analystList;
            context: { items: associateCoverageOptions }
          "
        ></ng-container>
      </ng-container>
      <ng-template #analystList let-items="items">
        <div class="long-list" *ngIf="items.length">
          <div class="account-option-list">
            <div>
              <div
                nz-menu-item
                class="account-option"
                *ngFor="let item of items"
              >
                <a [routerLink]="item.link">{{ item.name }}</a>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</nz-dropdown-menu>
